import { render, staticRenderFns } from "./SetPayPassword.vue?vue&type=template&id=f2a94aec&scoped=true"
import script from "./SetPayPassword.vue?vue&type=script&lang=js"
export * from "./SetPayPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPayPassword.vue?vue&type=style&index=0&id=f2a94aec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a94aec",
  null
  
)

export default component.exports